import type { FC, ReactNode } from 'react'

import { Logo } from '@/components/generals/logo'

import { footerColumns } from '@/constants/landing'
import { siteConfig } from '@/constants/site'

export const Footer: FC = (): ReactNode => {
    return (
        <footer className='px-5 pb-10 pt-16 sm:px-8'>
            <div className='mx-auto max-w-7xl'>
                <div className='grid gap-12 md:grid-cols-[1.4fr_repeat(3,minmax(0,1fr))]'>
                    <div className='max-w-xs'>
                        <a href='#hero' className='inline-flex items-center gap-2.5 text-ink' aria-label={`${siteConfig.name} home`}>
                            <Logo className='size-8' />

                            <span className='text-lg font-semibold tracking-[-0.02em]'>
                                {siteConfig.name}
                            </span>
                        </a>

                        <p className='mt-4 text-[15px] leading-relaxed text-muted-foreground'>
                            Physics you can touch. Live simulations for curious students, brilliant teachers and every classroom in between.
                        </p>
                    </div>

                    {footerColumns.map(column => (
                        <nav key={column.title} aria-label={column.title}>
                            <h2 className='font-mono text-[11px] uppercase tracking-[0.16em] text-muted-foreground'>
                                {column.title}
                            </h2>

                            <ul className='mt-4 flex flex-col gap-3'>
                                {column.links.map(link => (
                                    <li key={link.label}>
                                        <a href={link.href} className='text-[15px] text-ink transition-colors hover:text-brand'>
                                            {link.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    ))}
                </div>

                <div className='mt-16 flex flex-col gap-3 border-t border-hairline pt-8 text-sm text-muted-foreground sm:flex-row sm:items-center sm:justify-between'>
                    <p>© 2026 {siteConfig.name}. All rights reserved.</p>

                    <p className='font-mono text-[11px] uppercase tracking-[0.16em]'>
                        F = ma, still undefeated
                    </p>
                </div>
            </div>
        </footer>
    )
}
